// AUTH_TOKEN localStorage name for the authentication token
export const AUTH_TOKEN = 'YZAF6srew3IACQ6Sj9QIgIBHh9EKt4O7Kbm2qv7NVs';

// API_ENDPOINT is the API endpoint for production and developement
export const API_ENDPOINT = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:6868';